import { Box, Container, Typography, Button } from "@mui/material";
import { TypeAnimation } from "react-type-animation";
import Navbar from "./Navbar";
import { Link } from "react-scroll";
import {useSectionData } from "../hooks/useFirebaseData";
import HomeSkeleton from "./ui/HomeSkeleton";
import banner from "../assets/banner.png";

function Home() {
  const { data: homeData, loading } = useSectionData("home","home");
  if (loading) {
    return <HomeSkeleton />;
  }
  const bannerText = homeData?.home_banner_text ;
  const buttonText = homeData?.book_counseling ;
  const formattedBannerText = bannerText.replace(/\\n/g, '\n');

  return (
    <Box
      sx={{
        height: "100vh",
        backgroundImage: `url(${banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
        }}
      />
      <Navbar />
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          zIndex: 10,
        }}
      >
        <Container>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h5"
              sx={{
                color: "white",
                mb: 4,
                fontSize: {
                  xs: "1rem",
                  sm: "1.25rem",
                  md: "1.5rem",
                  lg: "1.75rem",
                  xl: "2rem",
                },
                textAlign: "center",
                whiteSpace: "pre-line", 
                textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                lineHeight: 1.5,
              }}
            >
              <TypeAnimation
                sequence={[
                  formattedBannerText,
                  1000,
                ]}
                wrapper="span"
                speed={50}
                style={{ 
                  fontFamily: "monospace", 
                  display: "block",
                  fontWeight: "bold"
                }}
                repeat={0}
              />
            </Typography>

            <Link
              to="counseling"
              smooth={true}
              duration={500}
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "white",
                  color: "#E37503",
                  px: 4,
                  py: 1.5,
                  fontSize: { xs: "1rem", md: "1.25rem" },
                  fontWeight: "bold",
                  '&:hover': {
                    backgroundColor: "grey.100",
                    transform: "translateY(-2px)",
                    boxShadow: 3,
                  },
                  transition: "all 0.3s ease",
                }}
              >
                {buttonText}
              </Button>
            </Link>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export default Home;